import { render, staticRenderFns } from "./PriceTableForm.vue?vue&type=template&id=9cce7f86&lang=pug"
import script from "./PriceTableForm.vue?vue&type=script&lang=js"
export * from "./PriceTableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports